<template>
    <ul class="checklist">
        <li v-for="option in options" v-bind:key="option" @click="onOptionSelect($event, option)"  class="custom-checkbox">
            <div class="p-checkbox p-component">
                <div :class="['p-checkbox-box', {'p-highlight': isSelected(option)}]">
                    <span :class="['p-checkbox-icon', {'pi pi-check': isSelected(option)}]"></span>
                </div>

            </div>
            <span>{{getOptionLabel(option)}}</span>
        </li>
    </ul>
</template>

<script>


    export default {
        name: "CheckList",
        props: ["modelValue", "options", "optionLabel", "optionValue"],
        setup(props, { emit }) {

            const getOptionLabel = (option) => {
                if (!option)
                    return "UNDEFINED";

                return props.optionLabel ? option[props.optionLabel] : option;
            };

            const getOptionValue = (option) => {
                return props.optionValue ? option[props.optionValue] : option;
            };

            const isSelected = (option) => {
                if (props.modelValue) {
                    let optionValue = option ? getOptionValue(option) : undefined;
                    return props.modelValue.some(val => val == optionValue);
                }
                return false;
            };

            const onOptionSelect = (event, option) => {
                let selected = isSelected(option);
                let value = null;
                if (selected)
                    value = props.modelValue.filter(val => val != getOptionValue(option));
                else
                    value = [...(props.modelValue || []), getOptionValue(option)];
                emit('update:modelValue', value);
                emit('change', { originalEvent: event, value: value });
            };


            return {
                isSelected,
                getOptionLabel,
                onOptionSelect,
            };
        }
    }
</script>